import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-executor-add-edit',
  templateUrl: './executor-add-edit.component.html',
  styleUrls: ['./executor-add-edit.component.scss']
})
export class ExecutorAddEditComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
